<template>
  <b-modal v-model="isModalActive" :id="'sideBar' + $store.state.sidebar" :can-cancel="false">
    <div class="form-modal-widget">
      <div class="form-modal-header">
        <h1>ADD VOTES MANUALLY</h1>
      </div>

      <div class="form-modal-body">
        <div class="participant-info">
          <div class="participant-image">
            <img v-if="participant && participant.image"
              :src="$store.state.ASSETS_BASE_URL + '/assets/uploaded/' + participant.image" />
            <img v-else-if="session && session.logo"
              :src="$store.state.ASSETS_BASE_URL + '/assets/uploaded/' + session.logo" />
          </div>
          <div class="participant-details">
            <h3>{{ participant ? participant.name : 'Participant' }}</h3>
            <p>Current Votes: <strong>{{ participant ? (participant.votes || 0) : 0 }}</strong></p>
          </div>
        </div>

        <div class="row">
          <b-field label="Number of Votes to Add" style="width: 100%">
            <b-numberinput v-model="form.votes" min="1" step="1" placeholder="Enter number of votes" :controls="true">
            </b-numberinput>
          </b-field>
        </div>

        <div class="row">
          <b-field label="Reason (Optional)" style="width: 100%">
            <b-input v-model="form.reason" type="textarea" maxlength="500"
              placeholder="Enter reason for adding votes manually">
            </b-input>
          </b-field>
        </div>

        <div class="vote-summary" v-if="form.votes > 0">
          <div class="summary-item">
            <span>Current Votes:</span>
            <strong>{{ participant ? (participant.votes || 0) : 0 }}</strong>
          </div>
          <div class="summary-item">
            <span>Votes to Add:</span>
            <strong>+{{ form.votes }}</strong>
          </div>
          <div class="summary-item total">
            <span>New Total:</span>
            <strong>{{ (participant ? (parseInt(participant.votes) || 0) : 0) + form.votes }}</strong>
          </div>
        </div>
      </div>

      <div class="form-modal-footer">
        <b-button :loading="submit_loading" @click="submitForm()" type="is-primary">
          ADD VOTES
        </b-button>
        <b-button @click="onCancel" type="is-primary" outlined>CANCEL</b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  components: {},
  props: {
    participant: {
      type: Object,
      default: null,
    },
    session: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    isModalActive: true,
    form: {
      votes: 1,
      reason: "",
    },
    submit_loading: false,
  }),
  watch: {},
  mounted() {
    let vm = this;
    vm.resetFormFields();
  },
  beforeDestroy() {
    let vm = this;
  },
  methods: {
    resetFormFields() {
      let vm = this;
      vm.form = {
        votes: 1,
        reason: "",
      };
    },
    submitForm() {
      let vm = this;

      // Validation
      const rules = {
        votes: {
          run: (value) => {
            if (!value || value < 1) {
              return "Number of votes must be at least 1";
            }
            return false;
          },
        },
      };

      if (vm.$isFieldsValidated(vm.form, rules)) {
        // Show confirmation dialog
        vm.$buefy.dialog.confirm({
          title: "Add Votes Manually",
          message: `Are you sure you want to add <strong>${vm.form.votes}</strong> votes to <strong>${vm.participant.name}</strong>?${vm.form.reason ? `<br><br><strong>Reason:</strong> ${vm.form.reason}` : ''}<br><br>This action will immediately increase their vote count and cannot be easily undone.`,
          confirmText: "Add Votes",
          type: "is-warning",
          hasIcon: true,
          onConfirm: () => {
            vm.submit_loading = true;

            const payload = {
              participant_id: vm.participant.id,
              session_id: vm.session.id,
              votes: vm.form.votes,
              reason: vm.form.reason,
              type: 'manual' // To distinguish from payment-based votes
            };

            vm.$store
              .dispatch("VOTING_ADD_VOTES_MANUALLY", payload)
              .then((response) => {
                vm.submit_loading = false;
                vm.$emit("onClose", response.data.return);
                vm.$notify({
                  group: "status",
                  type: "success",
                  title: "Success",
                  text: response.data.message || `Successfully added ${vm.form.votes} votes to ${vm.participant.name}`,
                });
              })
              .catch(({ response }) => {
                vm.submit_loading = false;
                vm.$notify({
                  group: "status",
                  type: "warn",
                  title: "OOPS!!!",
                  text: response.data.message || "Failed to add votes manually",
                });
              });
          },
        });
      }
    },
    onCancel() {
      let vm = this;
      vm.$emit("onCancel");
    },
  },
};
</script>

<style lang="scss" scoped>
.form-modal-widget {
  width: 600px;
  background: #fff;
  margin: 20px auto;
  border-radius: 5px;

  @media (max-width: 650px) {
    width: 95% !important;
  }

  @media (max-width: 500px) {
    width: 100% !important;
    margin: 0;
  }

  .form-modal-header {
    height: 60px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #ddd;
    padding: 0px 20px;
    justify-content: space-between;

    @media (max-width: 500px) {
      position: sticky;
      top: 0;
      z-index: 10;
      background: white;
    }

    h1 {
      font-size: 16px;
      font-weight: 600;
      color: #333;
    }
  }

  .form-modal-body {
    padding: 20px;
    min-height: 200px;

    .participant-info {
      display: flex;
      align-items: center;
      background: #f8f9fa;
      padding: 15px;
      border-radius: 8px;
      margin-bottom: 20px;

      .participant-image {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        overflow: hidden;
        margin-right: 15px;
        flex-shrink: 0;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .participant-details {
        flex: 1;

        h3 {
          margin: 0 0 5px 0;
          font-size: 18px;
          font-weight: 600;
          color: #333;
        }

        p {
          margin: 0;
          color: #666;
          font-size: 14px;
        }
      }
    }

    .row {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      margin-bottom: 15px;

      @media (max-width: 628px) {
        flex-direction: column;
        align-items: stretch !important;

        .field {
          width: 100% !important;
          margin-right: 0 !important;
        }
      }
    }

    .vote-summary {
      background: #e8f5e8;
      border: 1px solid #4caf50;
      border-radius: 8px;
      padding: 15px;
      margin-top: 20px;

      .summary-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 5px 0;
        font-size: 14px;

        &.total {
          border-top: 1px solid #4caf50;
          margin-top: 10px;
          padding-top: 10px;
          font-size: 16px;
          font-weight: 600;
          color: #2e7d32;
        }

        span {
          color: #333;
        }

        strong {
          color: #2e7d32;
        }
      }
    }
  }

  .form-modal-footer {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #ddd;
    padding: 0px 20px;
  }
}

#sideBartrue {
  left: 230px;

  @media (max-width: 768px) {
    left: 0;
  }

  .form-modal-widget {
    @media (max-width: 768px) {
      width: 95%;
    }
  }
}
</style>
